import Utilities from "../../pages/Utilities";
import { InternalUserRoles, InternalAndGuestUserRoles } from "../../constants/roles";
import { ReactComponent as UtilitiesIcon } from "../../assets/utilitiesicon.svg";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/utilities";

// Guest/third-party access to this module is controlled by the remote
// "ThirdPartyAccessToUtilitiesModule" feature flag (see FeatureFlagProvider),
// not a static build-time toggle. Internal users always have access
// regardless of the flag's state (see featureFlagBypassRoles below).
export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Utilities,
  allowedRoles: InternalAndGuestUserRoles,
  featureFlag: "ThirdPartyAccessToUtilitiesModule",
  featureFlagBypassRoles: InternalUserRoles,
  label: "Utilities",
  icon: () => <UtilitiesIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const utilitiesRoutes: { [key: string]: RouteConfig } = {
  utilities: baseRoute,
};
